module.exports = __webpack_public_path__ + "static/media/cinopsis.764f60d2.png";